import { render, staticRenderFns } from "./BatchesHeader.vue?vue&type=template&id=85acc6fa&"
import script from "./BatchesHeader.vue?vue&type=script&lang=js&"
export * from "./BatchesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85acc6fa')) {
      api.createRecord('85acc6fa', component.options)
    } else {
      api.reload('85acc6fa', component.options)
    }
    module.hot.accept("./BatchesHeader.vue?vue&type=template&id=85acc6fa&", function () {
      api.rerender('85acc6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchesHeader.vue"
export default component.exports